import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
// Functions
import { parseSecondsToMinutes } from "../../../../../../config/functions";
import { isClinicOrHome } from "../../../../../../config/validateApplication";
import { getProtocolTitle } from "../../../../../../config/validateProtocols";
// Components
import { DownloadButton, FileImg } from "./styles";
// Assets
import CSVImg from "../../../../../../assets/icons/ico_csv.svg";
import CSVDisabledImg from "../../../../../../assets/icons/ico_csv_grey.svg";

const DownloadCSV = ({ sessionsData }) => {
  const { software, patientId, protocolId } = useParams();
  const [t] = useTranslation("global");

  const getFileName = () => {
    const protocolTitle = t(getProtocolTitle("protocols", protocolId));
    const protocolTitleParsed = protocolTitle.replace(" ", "_");
    return `${t("patient")}${patientId}_${protocolTitleParsed}.csv`;
  };

  const generateCSV = () => {
    const headers = [
      `${t("downloadFiles_csv_sessionId")}`,
      `${t("downloadFiles_csv_startingDate")}`,
      `${t("downloadFiles_csv_prescriptionDuration")}`,
      `${t("score").toUpperCase()}`,
      `${t("downloadFiles_csv_totalErrors")}`,
      `${t("downloadFiles_csv_totalSuccess")}`,
      `${t("downloadFiles_csv_sessionDuration")}`,
    ];

    const rows = sessionsData.map((session) => [
      session.SESSION_ID,
      session.STARTING_DATE,
      parseSecondsToMinutes(session.PRESCRIPTION_DURATION),
      session.score ? session.score : 0,
      session.totalErrors ? session.totalErrors : 0,
      session.totalSuccess ? session.totalSuccess : 0,
      parseSecondsToMinutes(
        isClinicOrHome(software)
          ? session.PRESCRIPTION_DURATION
          : session["sessionDuration(seconds)"]
          ? session["sessionDuration(seconds)"]
          : 0
      ),
    ]);

    let csvContent = headers.join(",") + "\r\n";
    rows.forEach((row) => {
      csvContent += row.join(",") + "\r\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, getFileName());
  };

  return (
    <DownloadButton onClick={generateCSV} disabled={!sessionsData.length} cursor={sessionsData.length ? "pointer" : "auto"}>
      <FileImg src={sessionsData.length ? CSVImg : CSVDisabledImg} alt="ico-csv" />
    </DownloadButton>
  );
};

export default DownloadCSV;
